import { render, staticRenderFns } from "./ContentStats.vue?vue&type=template&id=7531e198&scoped=true"
import script from "./ContentStats.vue?vue&type=script&lang=js"
export * from "./ContentStats.vue?vue&type=script&lang=js"
import style0 from "./ContentStats.vue?vue&type=style&index=0&id=7531e198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7531e198",
  null
  
)

export default component.exports